import { useLocation, useNavigate, useRouter } from "@tanstack/react-router";


export default function useNav() {
	const location = useLocation();
	const navigate = useNavigate();
	const router = useRouter();

	const cid = location.search.sub_cid;
	const sgk = location.search.sub_gk;
	const ssk = location.search.sub_sk;
	const gid = location.search.sub_gid;

	return {
		location,
		keys: { cid, gid, sgk, ssk },
		go: navigate,
		replace: (to) => navigate({ to, replace: true }),
		back: () => router.history.back(),
		tab: (to) => window.open(to, "_blank"),
		open: (to) => window.location.href = to,
		preserve: (to) => navigate({ to, search: location.search }),
		redirectUri: (to) => navigate({ to, search: { redirect_uri: location.href } })
	};
};